import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const Dashboard = React.lazy(() => import("./Dashboard"));
const TenantDetail = React.lazy(() => import("./TenantDetail"));
const AutomationHistory = React.lazy(() => import("./AutomationHistory"));
const CommunicationHistory = React.lazy(() => import("./CommunicationHistory"));
const Templates = React.lazy(() => import("./Templates"));
const ManualTrigger = React.lazy(() => import("./ManualTrigger"));

const growthEngineModuleConfig: ModuleConfig = {
  id: "growth-engine",
  name: "Growth Engine",
  description: "Claude-powered tenant motivation system with daily pipeline analysis and personalized email/SMS campaigns",
  version: "1.0.0",
  enabled: true,
  category: "automation",
  order: 15,
  icon: "🚀",
  color: "#7C3AED",

  routes: [
    {
      path: "/growth-engine",
      component: Dashboard,
      permissions: ["GROWTH_ENGINE_VIEWER", "GROWTH_ENGINE_MANAGER", "GROWTH_ENGINE_ADMIN", "ADMIN"],
      useLayout: true,
    },
    {
      path: "/growth-engine/tenant/:tenantId",
      component: TenantDetail,
      permissions: ["GROWTH_ENGINE_VIEWER", "GROWTH_ENGINE_MANAGER", "GROWTH_ENGINE_ADMIN", "ADMIN"],
      useLayout: true,
    },
    {
      path: "/growth-engine/automation-history",
      component: AutomationHistory,
      permissions: ["GROWTH_ENGINE_VIEWER", "GROWTH_ENGINE_MANAGER", "GROWTH_ENGINE_ADMIN", "ADMIN"],
      useLayout: true,
    },
    {
      path: "/growth-engine/communication-history",
      component: CommunicationHistory,
      permissions: ["GROWTH_ENGINE_VIEWER", "GROWTH_ENGINE_MANAGER", "GROWTH_ENGINE_ADMIN", "ADMIN"],
      useLayout: true,
    },
    {
      path: "/growth-engine/templates",
      component: Templates,
      permissions: ["GROWTH_ENGINE_MANAGER", "GROWTH_ENGINE_ADMIN", "ADMIN"],
      useLayout: true,
    },
    {
      path: "/growth-engine/trigger",
      component: ManualTrigger,
      permissions: ["GROWTH_ENGINE_MANAGER", "GROWTH_ENGINE_ADMIN", "ADMIN"],
      useLayout: true,
      layoutOptions: { maxW: "container.lg" },
    },
  ],

  navigation: [
    {
      label: "Dashboard",
      path: "/growth-engine",
      icon: "🚀",
    },
    {
      label: "Automation History",
      path: "/growth-engine/automation-history",
      icon: "📋",
    },
    {
      label: "Communication History",
      path: "/growth-engine/communication-history",
      icon: "📨",
    },
    {
      label: "Templates",
      path: "/growth-engine/templates",
      icon: "📝",
      permissions: ["GROWTH_ENGINE_MANAGER", "GROWTH_ENGINE_ADMIN", "ADMIN"],
    },
    {
      label: "Manual Trigger",
      path: "/growth-engine/trigger",
      icon: "▶️",
      permissions: ["GROWTH_ENGINE_MANAGER", "GROWTH_ENGINE_ADMIN", "ADMIN"],
    },
  ],

  permissions: {
    view: ["GROWTH_ENGINE_VIEWER", "GROWTH_ENGINE_MANAGER", "GROWTH_ENGINE_ADMIN", "ADMIN"],
    create: ["GROWTH_ENGINE_MANAGER", "GROWTH_ENGINE_ADMIN", "ADMIN"],
    edit: ["GROWTH_ENGINE_MANAGER", "GROWTH_ENGINE_ADMIN", "ADMIN"],
    delete: ["GROWTH_ENGINE_ADMIN", "ADMIN"],
  },

  quickActions: [
    {
      label: "Growth Dashboard",
      path: "/growth-engine",
      icon: "🚀",
      description: "View all tenant pipeline health and automation status",
    },
    {
      label: "Manual Trigger",
      path: "/growth-engine/trigger",
      icon: "▶️",
      description: "Manually trigger motivation messages for a tenant",
    },
  ],
};

export default growthEngineModuleConfig;
